module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hasAccessDelete(_vm.FUNCTIONALITY)) ? _c('div', [(_vm.isLoading) ? _c('loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.forecasts), function(forecast) {
    return _c('div', {
      key: forecast.id
    }, [_c('input', {
      attrs: {
        "id": 'forecast_' + forecast.id,
        "type": "checkbox",
        "disabled": _vm.isDisabled(forecast)
      },
      domProps: {
        "checked": _vm.forecastItemMap.get(forecast.id)
      },
      on: {
        "change": function($event) {
          _vm.forecastItemMap.set(forecast.id, !_vm.forecastItemMap.get(forecast.id));
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "cutWordM",
      attrs: {
        "for": 'forecast_' + forecast.id
      }
    }, [_vm._v(_vm._s(forecast.name))])])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c459ecc4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/elements/catalogue/CatalogueItemManager.vue
// module id = 3360
// module chunks = 0